module.exports = __webpack_public_path__ + "img/insuranceVerificationCarouselImage.bc51ca4e.png";